module.exports = __webpack_public_path__ + "static/media/bg1.08c7b7d9.jpg";